import React from "react";

export default function CustomInputSearchV2({ icon, inputprops, onSearchClick, ...props }) {
  return (
    <div
      {...props}
      className={`custom-input relative sarabun text-18 ${props.className ?? ""}`}
    >
      <input
        {...inputprops}
        className={`w-full ${
          inputprops && inputprops.className ? inputprops.className : ""
        } ${inputprops && inputprops.error ? "error" : ""}`}
      />
      <div className="w-0 aspect-square">
        <img
          className={`absolute top-0 right-[min(2.44vw,25px)] w-[min(1.56vw,16px)] h-full ${
            inputprops?.value && inputprops.value.trim() !== '' ? 'cursor-pointer' : 'cursor-default'
          }`}
          src="/img/icons/icon-search.svg"
          onClick={onSearchClick}
          alt="search"
        />
      </div>
    </div>
  );
}